import { ConfigRecord } from "./ConfigRecord";
import * as GlobalTypes from "../../types";
import { DesiredStateItem } from "./DesiredState";
import * as uuid from 'uuid';

export type ScheduleRecord = ConfigRecord<ScheduleConfig>;
export type ScheduleConfig = {
    Schedule: ScheduleItem[]
};

export type ScheduleDow = 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday' | 'Sunday';
export type ScheduleItemTypes = "CONTROL" | "COMBINED_CONTROL" | "THEME" | "THEME_PLAYLIST";
export enum ScheduleTimeTypes {
    EXACT = "EXACT",
    SUNRISE = "SUNRISE",
    SUNSET = "SUNSET",
};
export class ScheduleItem {
    ScheduleElements: ScheduleElement[] = [];
    ItemUUID: GlobalTypes.UUIDV4 = "10f64765-68f5-4fe2-9c83-9CTHERCTSTAT";
    ItemType: ScheduleItemTypes = 'CONTROL';
}
export class ScheduleElement {
    Day:ScheduleDow = "Monday";
    Times: ScheduleTime[]
}
export class ScheduleTime extends DesiredStateItem {
  UUID: string;
  ReadyByTime: boolean;
  StartMethod: ScheduleTimeTypes = ScheduleTimeTypes.EXACT;
  StartTime: GlobalTypes.TimeString;
  EndMethod: ScheduleTimeTypes = ScheduleTimeTypes.EXACT;
  EndTime: GlobalTypes.TimeString;
  /** Introduced by AutoFilterVersion 41 */
  IgnoreSettingsJustTurnOnOff?: boolean;
}
